const initialState = () => ({
  isOpened: false,
  error: null,
  data: {
    diet: {
      professionalId: null,
      responsibleForPrescriptionName: null
    },
    medicament: {
      professionalId: null,
      responsibleForPrescriptionName: null
    },
    procedure: {
      professionalId: null,
      responsibleForPrescriptionName: null
    }
  },
  action: null,
  onSuccessCallback: null
});

const ACTION_KEY = 'PAD_CREATOR_ADD_PRESCRIPTION_MODAL';

const reducer = (state = initialState(), reduxAction) => {
  switch (reduxAction.type) {
    case `${ACTION_KEY}_OPEN`: {
      const { data, action } = reduxAction.payload;
      return {
        ...state,
        data,
        action,
        isOpened: true
      };
    }
    case `${ACTION_KEY}_CLOSE`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
